import { render, staticRenderFns } from "./BlogPostsList.vue?vue&type=template&id=d31256f6&scoped=true&"
import script from "./BlogPostsList.vue?vue&type=script&lang=js&"
export * from "./BlogPostsList.vue?vue&type=script&lang=js&"
import style0 from "./BlogPostsList.vue?vue&type=style&index=0&id=d31256f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31256f6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogPostsListItem: require('/home/circleci/repo/components/blog/BlogPostsListItem.vue').default})
